
window.addEventListener('DOMContentLoaded', () => {
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
     const staticImages = this.querySelectorAll('[data-static-image]');
staticImages.forEach((imageWrapper) => {
  const existing = imageWrapper.cloneNode(true);
  imageWrapper.replaceWith(existing);
});
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
});
(function () {
  const DEBUG = false; // set true while debugging

  function log(...args) {
    if (DEBUG) console.log('[subfreq]', ...args);
  }

  // Helper: safe dataset getter
  function ds(el, name) {
    return el && el.dataset ? el.dataset[name] : undefined;
  }

  // Update Shopify line item properties: use POST /cart/change.js with id=line.key and properties
  async function saveFrequencyToCart(wrapper, newFrequency) {
  try {
    const cartResp = await fetch('/cart.js', { cache: 'no-store' });
    if (!cartResp.ok) throw new Error('Failed to fetch cart');
    const cart = await cartResp.json();

    const lineIndex = parseInt(wrapper.dataset.lineIndex, 10);
    const lineItem = cart.items[lineIndex];

    if (!lineItem) throw new Error('Line item not found via index');
       const qtyInput = wrapper.querySelector('.quantity__input');
    const newQty = qtyInput ? parseInt(qtyInput.value, 10) : lineItem.quantity;

    const updatedProperties = Object.assign({}, lineItem.properties || {});
    updatedProperties.frequency = String(newFrequency);

    const updateResp = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: lineIndex + 1, // IMPORTANT: /cart/change.js uses 1-based line numbers
         quantity: newQty, 
        properties: updatedProperties
      })
    });

    if (!updateResp.ok) throw new Error(await updateResp.text());

    const updatedCart = await updateResp.json();

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: updatedCart }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: updatedCart }));

    return updatedCart;
  } catch (err) {
    console.error('[subfreq] saveFrequencyToCart error:', err);
    throw err;
  }
}


  // Restore current frequency from Shopify cart for a wrapper element
  async function restoreFrequencyFromCart(wrapper) {
    const cartKey = wrapper.getAttribute('data-cart-key');
    if (!cartKey) return;

    try {
      const cartResp = await fetch('/cart.js', { cache: 'no-store' });
      if (!cartResp.ok) throw new Error('Failed to fetch cart');
      const cart = await cartResp.json();

      const item = cart.items.find(i => i.key === cartKey);
      if (!item) return;

      const savedFrequency = (item.properties && item.properties.frequency) ? String(item.properties.frequency) : null;
      const currentEl = wrapper.querySelector('.subscription-current');
      const options = Array.from(wrapper.querySelectorAll('.subscription-option'));

      options.forEach(opt => opt.classList.remove('selected'));

      if (savedFrequency) {
        const match = options.find(opt => String(opt.getAttribute('data-value')) === savedFrequency);
        if (match) {
          match.classList.add('selected');
          if (currentEl) currentEl.textContent = match.getAttribute('data-text');
          return;
        }
      }

      // Fallback: if no saved value, try to match by text (handles initial page load)
      if (currentEl) {
        const currentText = currentEl.textContent && currentEl.textContent.trim();
        const matchByText = options.find(opt => String(opt.getAttribute('data-text')).trim() === currentText);
        if (matchByText) {
          matchByText.classList.add('selected');
        }
      }
    } catch (err) {
      console.error('[subfreq] restoreFrequencyFromCart error for', cartKey, err);
    }
  }

  // Single wrapper initialization (idempotent)
  function initWrapper(wrapper) {
    if (!wrapper || wrapper.getAttribute('data-sub-init') === 'true') return;
    wrapper.setAttribute('data-sub-init', 'true');

    const current = wrapper.querySelector('.subscription-current');
    const dropdown = wrapper.querySelector('.subscription-dropdown');
    const arrow = wrapper.querySelector('.subscription-arrow');

    if (!current || !dropdown) return;

    // Restore UI from live cart data
    restoreFrequencyFromCart(wrapper);

    // Toggle open/close when clicking wrapper (but ignore clicks inside dropdown/options)
    wrapper.addEventListener('click', (e) => {
      const targetOption = e.target.closest('.subscription-option');
      // If click landed on an option, leave handling to option click handler
      if (targetOption) return;

      // Toggle dropdown open, and close others
      const openBefore = wrapper.classList.contains('open');
      document.querySelectorAll('.subscription-frequency-line.open').forEach(el => {
        if (el !== wrapper) el.classList.remove('open');
      });

      if (openBefore) wrapper.classList.remove('open');
      else wrapper.classList.add('open');
    });

    // Option click handling (delegate local to wrapper)
    dropdown.addEventListener('click', async (e) => {
  const opt = e.target.closest('.subscription-option');
  if (!opt) return;

  const newValue = opt.dataset.value;
  const newText = opt.dataset.text;

  current.textContent = 'Updating...';

  try {
    await saveFrequencyToCart(wrapper, newValue);

    current.textContent = newText;
  } catch (err) {
    current.textContent = newText; // fallback
  }
  wrapper.classList.remove('open');
});


    // Accessibility: allow keyboard navigation on wrapper (Enter / Space toggle)
    wrapper.addEventListener('keydown', (e) => {
      if (e.code === 'Enter' || e.code === 'Space') {
        e.preventDefault();
        wrapper.click();
      } else if (e.code === 'Escape') {
        wrapper.classList.remove('open');
      }
    });
  }

  // Initialize every wrapper on the page (idempotent)
  function initializeSubscriptionDropdowns() {
    log('initializeSubscriptionDropdowns start');
    const wrappers = Array.from(document.querySelectorAll('.subscription-frequency-line'));
    if (!wrappers.length) {
      log('no frequency wrappers found');
      return;
    }

    wrappers.forEach(wrapper => initWrapper(wrapper));
  }

  /* ---------- Re-init logic after DOM changes / cart events ---------- */

  // Debounce helper
  let initTimer = null;
  function debouncedInit(delay = 200) {
    clearTimeout(initTimer);
    initTimer = setTimeout(() => {
      initializeSubscriptionDropdowns();
    }, delay);
  }

  // Re-init when cart events fire (these events are fired by the module above/other scripts)
  ['cart:refresh', 'cart:refreshed', 'cart:updated', 'ajaxCart.afterCartLoad', 'cart-drawer:open', 'cart-drawer:close'].forEach(evt => {
    document.addEventListener(evt, () => debouncedInit(150));
  });

  // MutationObserver to detect cart drawer DOM replacement (Dawn re-renders entire drawer)
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (const m of mutations) {
      if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
        // If any added node contains subscription-frequency-line or cart drawer container, reinit
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches && (node.matches('.subscription-frequency-line') || node.matches('.drawer__inner') || node.matches('#CartDrawer') || node.closest && node.querySelector('.subscription-frequency-line'))) {
            shouldRun = true;
            break;
          }
        }
      }
      if (shouldRun) break;
    }
    if (shouldRun) debouncedInit();
  });

  // Observe body for changes (start immediately)
  try {
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (err) {
    // ignore if observe fails at early load
    log('observer failed to start', err);
  }

  // Initial call on DOMContentLoaded; if already loaded call immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => initializeSubscriptionDropdowns(), 300);
    });
  } else {
    setTimeout(() => initializeSubscriptionDropdowns(), 100);
  }

  // Expose small API in case you want to manually trigger initialization
  window.initializeSubscriptionDropdowns = initializeSubscriptionDropdowns;
  window.saveFrequencyToCart = saveFrequencyToCart;
})();

document.addEventListener('click', function (e) {
  const checkoutBtn = e.target.closest(
    'a[href="/checkout"], a[href^="/checkout"], button[name="checkout"], form[action="/checkout"]'
  );
  if (!checkoutBtn) return;

  // FOR ALL: same tab
  checkoutBtn.removeAttribute('target');
  e.preventDefault();
  window.location.href = checkoutBtn.href || '/checkout';
});

/* ------------------------------
   FIX: Update Quantity in Shopify Cart
   ------------------------------ */
async function updateCartQuantity(line, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: line,
      quantity: qty
    })
  }).then(res => res.json());
}

/* attach plus/minus buttons */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.wk-qty-btn');
  if (!btn) return;

  const line = parseInt(btn.dataset.line, 10);
  const input = document.querySelector(`#qty-${line}`);
  let qty = parseInt(input.value);

  if (btn.classList.contains('plus')) qty++;
  if (btn.classList.contains('minus')) qty--;

  if (qty < 1) qty = 1;

  input.value = qty;

  await updateCartQuantity(line, qty);

  document.dispatchEvent(new Event('cart:refresh'));
});